import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import logoDark from "../../../assets/images/logo-dark.svg";
import logoLight from "../../../assets/images/logo-light.svg";
import { useDispatch, useSelector } from "react-redux";
// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";
import { userLoginAction } from "../../../slices/auth/login/action";
import { deleteItem, getItem, setItem } from "../../../helpers/cookies";

const Login = ({ theme }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const userState = useSelector((state) => state.user || {});
  const { errorMsg } = userState || {};
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userName = getItem("email") || "";
  const pwd = getItem("password") || "";
  const [rememberMe, setRememberMe] = useState(getItem("rememberMe") || false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: userName,
      password: pwd,
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      const { email, password } = values || {};

      // Check rememberMe and store it in cookies
      if (rememberMe) {
        setItem("rememberMe", true);
        setItem("email", email);
        setItem("password", password);
      } else {
        deleteItem("rememberMe");
        deleteItem("email");
        deleteItem("password");
      }
      triggerApi({ email, password });
    },
  });

  // Api Call
  const triggerApi = async ({ email, password }) => {
    await userLoginAction({ input: { email, password } }, dispatch, history);
    setIsLoading(false);
  };

  const navigateToDashboard = () => {
    window.location.href = "/dashboard";
  };

  return (
    <Container>
      <Row className="border-bottom">
        <Col
          md="7"
          className="m-auto d-flex justify-content-between align-items-center py-4"
        >
          <Link
            to="/"
            className={`logo ${theme === "dark" ? "logo-light" : "logo-dark"}`}
          >
            <img
              src="https://assets.danubehome.com/media/assets/svg-v2/logoEn.svg"
              alt="large logo"
              height="22"
            />
          </Link>
          <div className="d-flex gap-3">
            {/* <Button
              color="primary"
              outline
              onClick={() => history("/register")}
            >
              Sign Up
            </Button> */}
          </div>
        </Col>
      </Row>

      <Row>
        <Col
          md="3"
          className="position-absolute top-50 start-50 translate-middle"
        >
          <div className="px-2 pb-3 text-center">
            <h4>Welcome back</h4>
            <h6>Log in to access Danube Partners.</h6>
          </div>
          {errorMsg && <Alert color="danger"> {errorMsg} </Alert>}
          <Card>
            <Form
              action="#"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="p-5">
                <Row>
                  <Col md={12} className="mb-3">
                    <label className="form-label">Email</label>
                    <Input
                      autoComplete="off"
                      name="email"
                      className="form-control"
                      placeholder="Enter email"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email
                          ? true
                          : false
                      }
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col md={12} className="mb-3">
                    <label className="form-label">Password</label>
                    <Input
                      name="password"
                      value={validation.values.password || ""}
                      type={showPassword ? "text" : "password"}
                      className="form-control pe-5"
                      placeholder="Enter Password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.password &&
                        validation.errors.password
                          ? true
                          : false
                      }
                    />
                    {validation.touched.password &&
                    validation.errors.password ? (
                      <FormFeedback type="invalid">
                        {validation.errors.password}
                      </FormFeedback>
                    ) : null}
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                      type="button"
                      id="password-addon"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </Col>
                  <Col md={12} className="mb-3">
                    <div className="form-check mb-0">
                      <Input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="auth-remember-check"
                        onClick={(e) => setRememberMe(e.target.checked)}
                        checked={rememberMe}
                      />
                      <Label
                        className="form-check-label"
                        htmlFor="auth-remember-check"
                      >
                        Remember me
                      </Label>
                    </div>
                  </Col>
                  <Col md={12} className="mb-3">
                    <Button
                      size="md"
                      color="primary"
                      className="w-100"
                      type="submit"
                    >
                      {isLoading ? (
                        <Spinner size="sm" className="me-2">
                          Loading...
                        </Spinner>
                      ) : null}
                      Sign In
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </Card>
          <div className="d-flex flex-column justify-content-center align-items-center gap-2 fs-13">
            <Link
              className="text-info text-decoration-underline"
              to="/register"
            >
              Are you a new user? Sign up here
            </Link>
            <Link
              className="text-info text-decoration-underline"
              to="/reset-password"
            >
              Forgot your password? Reset it here
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
